export default __webpack_public_path__ + "static/media/dot.ee909a84.svg";